export const SESSION_ACTIVITY_EVENTS = ["pointerdown", "keydown", "touchstart"];
export const SESSION_ACTIVITY_THROTTLE_MS = 5 * 60 * 1000;
const LEGACY_REMEMBERED_EMAIL_KEY = "licitx_remembered_email";

export const clearLegacyRememberedEmail = (storage = window.localStorage) => {
    try {
        storage.removeItem(LEGACY_REMEMBERED_EMAIL_KEY);
    } catch {
        // El almacenamiento puede estar bloqueado por políticas del navegador.
    }
};

export const buildLoginPayload = (email, password, keepSignedIn = false) => ({
    email,
    password,
    keep_signed_in: Boolean(keepSignedIn),
});

export const createActivityReporter = (
    send,
    { now = () => Date.now(), throttleMs = SESSION_ACTIVITY_THROTTLE_MS } = {},
) => {
    let lastSentAt = null;
    let inFlight = false;

    return () => {
        const current = now();
        if (inFlight || (lastSentAt !== null && current - lastSentAt < throttleMs)) {
            return false;
        }
        lastSentAt = current;
        inFlight = true;
        Promise.resolve()
            .then(send)
            .catch(() => {})
            .finally(() => { inFlight = false; });
        return true;
    };
};
